export default "__VITE_ASSET__CttTMN1r__"